<template>
    <v-app>
        <v-container>
            <v-layout row>
                <v-flex xs12 sm8 offset-sm2>
                    <v-card>
                        <v-card-title primary-title>
                            <h3 class="mx-auto teal--text text--accent-4 font-weight-regular">
                                <v-icon class="pb-1" color="teal accent-4">
                                    lock
                                </v-icon>
                                Register:
                            </h3>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-form ref="form">
                                    <v-layout class="pb-2" row>
                                        <v-flex xs12>
                                            <v-text-field
                                                    v-model="user.email"
                                                    type="email"
                                                    required
                                                    :rules="emailRules"
                                            >
                                                <template slot="label">
                                                    <v-icon small style="vertical-align: middle">email</v-icon>
                                                    Email
                                                </template>
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout class="pb-2" row>
                                        <v-flex xs12>
                                            <v-text-field
                                                    v-model="user.username"
                                                    type="text"
                                                    required
                                                    :rules="generalRules"
                                            >
                                                <template slot="label">
                                                    <v-icon small style="vertical-align: middle">person</v-icon>
                                                    User Name
                                                </template>
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout class="pb-2" row>
                                        <v-flex xs12>
                                            <v-text-field
                                                    v-model="user.first_name"
                                                    type="text"
                                                    required
                                                    :rules="generalRules"
                                            >
                                                <template slot="label">
                                                    <v-icon small style="vertical-align: middle">person</v-icon>
                                                    First Name
                                                </template>
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout class="pb-2" row>
                                        <v-flex xs12>
                                            <v-text-field
                                                    v-model="user.last_name"
                                                    type="text"
                                                    required
                                                    :rules="generalRules"
                                            >
                                                <template slot="label">
                                                    <v-icon small style="vertical-align: middle">person</v-icon>
                                                    Last Name
                                                </template>
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout class="pb-2" row>
                                        <v-flex xs12>
                                            <v-text-field
                                                    v-model="password"
                                                    type="password"
                                                    :append-icon="showPassword ? 'visibility_off' : 'visibility'"
                                                    required
                                                    :type="showPassword ? 'text' : 'password'"
                                                    required
                                                    :rules="passwordRules"
                                                    @click:append="showPassword = !showPassword"
                                            >
                                                <template slot="label">
                                                    <v-icon small style="vertical-align: middle">lock</v-icon>
                                                    Password
                                                </template>
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout class="pb-2" row>
                                        <v-flex xs12>
                                            <v-text-field
                                                    type="password"
                                                    :append-icon="showPasswordConfirmation ? 'visibility_off' : 'visibility'"
                                                    required
                                                    :type="showPasswordConfirmation ? 'text' : 'password'"
                                                    required
                                                    :rules="passwordConfirmationRules"
                                                    @click:append="showPasswordConfirmation = !showPasswordConfirmation"
                                            >
                                                <template slot="label">
                                                    <v-icon small style="vertical-align: middle">lock</v-icon>
                                                    Password Confirmation
                                                </template>
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                    <div v-if="registerError" class="mt-4 alert alert-danger" role="alert">
                                        <strong>Something went wrong</strong> Try to register one more time
                                    </div>
                                    <v-layout row>
                                        <v-flex xs12 class="text-center">
                                            <v-btn color="" to="/">
                                                <v-icon small>
                                                    arrow_back
                                                </v-icon>
                                                &nbsp Back to Log In
                                            </v-btn>
                                            <v-btn color="teal accent-4 white--text" @click="attemtpToRegister">Register
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-form>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-app>
</template>

<script>
    export default {
        data() {
            return {
                generalRules: [
                    v => !!v || 'Field is required',
                ],
                passwordRules: [
                    v => !!v || 'Field is required',
                    v => v.length > 5 || 'Minimum 6 characters'
                ],
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        .test(v) || 'E-mail must be valid',
                ],
                user: {
                    username: '',
                    first_name: '',
                    last_name: '',
                    email: '',
                    password: ''
                },
                password: '',
                showPassword: false,
                showPasswordConfirmation: false,
                registerError: false
            }
        },
        computed: {
            passwordConfirmationRules() {
                const rules = [];
                rules.push(...this.passwordRules);
                rules.push(v => v.length > 5 || 'Minimum 6 characters');
                if (this.password) {
                    const rule =
                        v => (!!v && v) === this.password ||
                            'Password Confirmation do not match'
                    rules.push(rule)
                }
                return rules;
            }
        },
        watch: {
            password: 'validate'
        },
        methods: {
            attemtpToRegister() {
                if (this.$refs.form.validate()) {
                    this.user.password = this.password;
                    this.$http.post('/users', this.user).then((response) => {
                        if (response.status === 200) {
                            this.$router.push('/login?registered=true');
                        }
                    }, (error) => {
                        this.registerError = true
                    })

                }
            },
            validate() {
                this.$refs.form.validate();
            }
        }
    }
</script>

<style>
</style>
